import { DocumentType, IdentityDocumentType } from "@finbackoffice/enums";
import { useContext, useState, useCallback } from "react";
import { ClientBFFContext } from "../providers";

export const useUploadFiles = () => {
    const client = useContext(ClientBFFContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const uploadFiles = useCallback(
        async (files: File[], path: string) => {
            try {
                let fileIds: number[] = [];

                const fetchPromises = files.map(async (file) => {
                    const res = await client.createFile({
                        path: path,
                        filename: file.name,
                        body: file,
                    });
                    return res;
                });
                const results = await Promise.all(fetchPromises);
                fileIds = results.map((result) => result.id);
                return fileIds;
            } catch (err: any) {
                const error = err.response?.data || err;
                setError(error.message);
                return [];
            }
        },
        [client],
    );

    const submitIdentityDocument = useCallback(
        async (files: File[], type: IdentityDocumentType) => {
            setLoading(true);
            try {
                let response = null;
                const fileIds = await uploadFiles(files, "kyc/documents");
                if (fileIds.length) {
                    response = await client.createDocument({
                        document_type: DocumentType.IDENTITY_DOCUMENT,
                        identity_document_type: type,
                        files: fileIds,
                    });
                } else {
                    setError("File ids unavailable");
                }
                setLoading(false);
                return response;
            } catch (err: any) {
                const error = err.response?.data || err;
                setError(error.message);
                setLoading(false);
                return null;
            }
        },
        [client, uploadFiles],
    );

    const submitAddressDocument = useCallback(
        async (files: File[]) => {
            setLoading(true);
            try {
                let response = null;
                const fileIds = await uploadFiles(files, "kyc/address");
                if (fileIds.length) {
                    response = await client.createDocument({
                        document_type: DocumentType.ADDRESS,
                        files: fileIds,
                    });
                } else {
                    setError("File ids unavailable");
                }
                setLoading(false);
                return response;
            } catch (err: any) {
                const error = err.response?.data || err;
                setError(error.message);
                setLoading(false);
                return null;
            }
        },
        [client, uploadFiles],
    );

    const submitPaymentProof = useCallback(
        async (files: File[]) => {
            setLoading(true);
            try {
                let response = null;
                const fileIds = await uploadFiles(files, "kyc/address");
                if (fileIds.length) {
                    response = await client.createDocument({
                        document_type: DocumentType.PAYMENT,
                        files: fileIds,
                    });
                } else {
                    setError("File ids unavailable");
                }
                setLoading(false);
                return response;
            } catch (err: any) {
                const error = err.response?.data || err;
                setError(error.message);
                setLoading(false);
                return null;
            }
        },
        [client, uploadFiles],
    );

    return {
        submitIdentityDocument,
        submitAddressDocument,
        submitPaymentProof,
        error,
        loading,
    };
};
